import { useRouter } from "next/router";
import styles from "./Overview.module.css";
import { logEvent } from "../../Analytics/google-analytics";
import { trackClick } from "../../../scripts/segment";
import { pageName } from "../../../lib/utils/events_utils";
import { fireEvent } from "../../../utils/ga";
import { EVENTS_CONSTANTS } from "../../../constant/events";
import withLogin from "../../Login/withLogin";
import { flowTypes } from "../../Login/LoginConstants";
import { imageBasePath } from "lib/utils/imageUtils";

const Overview = ({ user, initLogin, features }) => {
  const router = useRouter();

  return (
    <div className={styles.overview}>
      <h6>The first choice of every international student</h6>
      <h2>Education Loans for MS in US</h2>
      <div className={styles.overviewQuoteImage}>
        <div className={styles.overviewImage}>
          <img
            className="object-contain"
            src="https://ik.imagekit.io/onsnhxjshmp/Leap_Finance/favor_point_image__zUrVlBYL.png"
          />
        </div>
        <div className={styles.overviewQuote}>
          <p>
            With the best financial structuring and advanced technology to
            support you, our loans are for ambitious Indians students pursuing
            international graduate education.
          </p>
          <div className={styles.overviewFeatures}>
            {features?.map((feature, id) => (
              <div key={`overview-features-${id}`}>
                <img
                  src={`${imageBasePath}/assets/images/new-home/${feature?.imageName}`}
                />
                <p>{feature?.text}</p>
              </div>
            ))}
          </div>
          <div className={styles.overviewButton}>
            <a
              onClick={() => {
                logEvent("IS Loan Features", "Get Loan Offer", "Hero-CTA");
                fireEvent(EVENTS_CONSTANTS.INSCHOOL_GET_LOAN_OFFER);
                if (user) {
                  router.push("/applications?clickId=40");
                } else {
                  trackClick(pageName.INSCHOOL_LOAN_FEATURES_US_PAGE, {
                    widgetName: "Hero",
                    widgetFormat: "Banner",
                    contentName: "Get Loan Offer",
                    contentFormat: "Button",
                  });
                  initLogin(true, "", flowTypes.INSCHOOL);
                }
              }}
            >
              Get Loan Offer
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withLogin(Overview);
